import 'slick';
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

( ( $ ) => {
	$.fn.createProductOverview = function () {
		this.each( function () {
			return new ProductOverview( this );
		} );
	};
	$( document ).ready( () => {
		$( '.product-overview' ).createProductOverview();
	} );

	const slickOptions = {
		slider: {
			arrows: false,
			dots: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 300,
			mobileFirst: true,
			swipe: true,
			fade: true,
			autoplay: false,
			adaptiveHeight: false,
			asNavFor: '.product-slider__nav',
			prevArrow: '<div class=\'icon-arrow-left\'>',
			nextArrow: '<div class=\'icon-arrow-right\'>',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						dots: false
					}
				}
			]
		},
		nav: {
			arrows: true,
			dots: false,
			infinite: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			speed: 300,
			vertical: true,
			mobileFirst: true,
			autoplay: false,
			focusOnSelect: true,
			rows: 0,
			asNavFor: '.product-slider',
			prevArrow: '<div class=\'icon-arrow-up\'>',
			nextArrow: '<div class=\'icon-arrow-down\'>'
		}
	};

	function ProductOverview( element ) {
		const $overview = $( element ),
			$productImages = $overview.find( '.product-images' ),
			$productSlider = $overview.find( '.product-slider' ),
			$productSliderNav = $overview.find( '.product-slider__nav' ),
			$window = $( window ),
			scrollMagicController = new ScrollMagic.Controller();

		$productSlider.slick( slickOptions.slider );
		$productSliderNav.slick( slickOptions.nav );
		const scene = new ScrollMagic.Scene( {
			triggerElement: '.product-overview',
			triggerHook: 'onLeave',
			duration: $( '.product-highlights' ).height(),
			offset: -160
		} ).addTo( scrollMagicController );

		let resizeDebounce,
			currentSlide = null;
			
		$window.on( 'resize', () => {
			clearTimeout( resizeDebounce );
			adjustScenePin();
			if( null === currentSlide ) {
				currentSlide = $productSliderNav.slick( 'slickCurrentSlide' );
				$productSliderNav.slick( 'unslick' );
			}
			
			resizeDebounce = setTimeout( () => {
				$productSliderNav.slick( slickOptions.nav );
				
				setTimeout( () => {
					$productSliderNav.slick( 'goTo', currentSlide, true ); 
					currentSlide = null;
				} );
			}, 100 );
		} );

		function adjustScenePin() {
			if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
				scene.setPin( $productImages[0], { pushFollowers: true } );
			} else {
				scene.removePin( $productImages[0], true );
			}
		}
		$window.trigger( 'resize' );
	}
} )( jQuery );